import type { MessengerMessage } from '@/api/client';

/**
 * id сообщения, перед которым показываем «Непрочитанные сообщения»:
 * первое входящее (не от текущего пользователя) после курсора last_read.
 * Согласовано с логикой unread_count на сервере (только сообщения собеседника).
 */
export function firstUnreadPeerDividerMessageId(
  messages: readonly MessengerMessage[],
  lastReadMessageId: string | null,
  currentUserId: string
): string | null {
  if (messages.length === 0) return null;

  const readIdx = lastReadMessageId
    ? messages.findIndex((m) => m.id === lastReadMessageId)
    : -1;

  const scanFrom = readIdx >= 0 ? readIdx + 1 : 0;

  for (let i = scanFrom; i < messages.length; i++) {
    const m = messages[i];
    if (String(m.sender_id) !== String(currentUserId)) {
      return m.id;
    }
  }
  return null;
}
